import { render } from "./FaqCreateModal.vue?vue&type=template&id=f9b3008c&scoped=true&ts=true"
import script from "./FaqCreateModal.vue?vue&type=script&lang=ts"
export * from "./FaqCreateModal.vue?vue&type=script&lang=ts"

import "./FaqCreateModal.vue?vue&type=style&index=0&id=f9b3008c&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9b3008c"]])

export default __exports__